module.exports = __webpack_public_path__ + "img/okk.c455ac52.png";